import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/footwear"
    exact
    path="/business/showcase/footwear"
    component={AsyncPage}
  />,
];
